<div class="spacer" [ngStyle]="{ height: height }"></div>
